import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 0 0 1rem;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};

  @media (max-width: 750px) {
    border: none;
  }
`;

export const Container = styled.div`
  display: grid;
  align-items: center;

  grid-template-columns: 0.95fr 1.05fr;
  gap: 1rem;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 750px) {
    display: flex;
    border: none;

    grid-template-columns: 1fr;
  }

  @media (max-width: 530px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const Image = styled.img`
  height: 8.5rem;
  max-width: 15rem;

  border-radius: 0.5rem;

  @media (max-width: 1080px) {
    height: 8.313rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 530px) {
    width: 100%;
  }
`;

export const ProductTitle = styled.h2`
  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.688rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Strong = styled.strong`
  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.688rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const Paragraph = styled.p`
  margin: 0;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const SubscritionWarning = styled.p`
  margin: 1rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const SubscritionWarningStrong = styled.strong`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;
